import onApproveSosRequest from './onApproveSosRequest';
import onRejectSosRequest from './onRejectSosRequest';
import onGetSosRequests from './onGetSosRequests';

export default {
  onApproveSosRequest,
  onGetSosRequests,
  onRejectSosRequest,
};
